export default "__VITE_ASSET__p5riBqEm__"